import React from 'react';
import { List } from 'semantic-ui-react';

import NavigationDropdownListItem from './NavigationDropdownListItem';
import type { NavigationItem } from './types';

interface MobileNavigationProps {
  items: NavigationItem[];
}

const MobileNavigation = ({ items }: MobileNavigationProps) => {
  return (
    <List size='huge' className='nav-list-mobile'>
      {items.map((child) => (
        <NavigationDropdownListItem key={child.url} item={child} />
      ))}
    </List>
  );
};

export default MobileNavigation;